import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetProductsDto } from '@/types/dtos/orders/response/get-products.dto.ts';

export const ADMIN_PRODUCTS_QUERY_KEY = 'admin-products';

export type AdminProductsFilters = {
  kind?: string;
  scopeType?: string;
};

function productsUrl(filters: AdminProductsFilters): string {
  const base = `${import.meta.env.VITE_API_URL}/products`;
  const params = new URLSearchParams();
  if (filters.kind?.trim()) {
    params.set('kind', filters.kind.trim());
  }
  if (filters.scopeType?.trim()) {
    params.set('scopeType', filters.scopeType.trim());
  }
  const q = params.toString();
  return q ? `${base}?${q}` : base;
}

export const useAdminProductsQuery = (filters: AdminProductsFilters = {}) => {
  const { getToken } = useAuth();
  const kind = filters.kind ?? '';
  const scopeType = filters.scopeType ?? '';

  return useQuery({
    queryKey: [ADMIN_PRODUCTS_QUERY_KEY, kind, scopeType],
    queryFn: async () => {
      const token = await getToken();
      const url = productsUrl({ kind, scopeType });
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? '' }) as Promise<GetProductsDto>;
    },
  });
};
